import * as actionTypes from './actionTypes';
import axios from 'axios';
import getFlightsResponse from '../../assets/json/getFlights.json';
import pollingResponse from '../../assets/json/polling.json';

let prod = false;
let pollingCheckFailArray = [];

const emptyPollingCheckArray = () => {
    pollingCheckFailArray = [];
}

export const setFlights = (flights, isPolling) => {
	if(isPolling) {
		flights["resultData"] = [{fltSchedule: flights.fltSchedule, fareDetails: flights.fareDetails}];
		flights["eagerFetch"] = "true";
	}
    return {
        type: actionTypes.SET_FLIGHTS,
        flights: flights,
        isPolling: isPolling
    }
}

export const getFlightsFailed = () => {
    return {
        type: actionTypes.GET_FLIGHTS_FAILED
    }
}

const getPollingFlights = (pollingId, pollingDelay, pollingLength, vDispatch) => {
        const parsedpollingFlights = pollingResponse;
        if(parsedpollingFlights.isError !== "1" &&	!parsedpollingFlights.shouldRetry && Number(parsedpollingFlights.isFlights) !== 0) {
                vDispatch(setFlights(parsedpollingFlights, true));
        } else if(parsedpollingFlights.isError !== "1" && parsedpollingFlights.shouldRetry){
                getPollingFlights(pollingId, pollingDelay, pollingLength, vDispatch);
        } else if(parsedpollingFlights.isError === "1" && parsedpollingFlights.shouldRetry) {
            vDispatch(increasePollingCounter());
        } else if(parsedpollingFlights.isError === "0" && !parsedpollingFlights.shouldRetry && parsedpollingFlights.isFlights === "0") {
            pollingCheckFailArray.push("fail");
            if(pollingCheckFailArray.length === pollingLength) {
                vDispatch(getFlightsFailed());
            }
        }
		// if(!pollingDelay || parseInt(pollingDelay, 10) < 1) {
		// 	pollingDelay = 0;
        // }
        // let url = 'http://localhost:3000/flights/getPollingFlights?polling_id=';
        // if(prod) {
        //     url = 'https://secure.yatra.com/quicksilvercontroller/flights/getPollingFlights?polling_id=';
        // }
		// setTimeout(() => {
		// 		axios.get(
		// 			url + pollingId, { headers: {'ssoToken': localStorage.getItem('ssoToken')} }
		// 		).then(pollData => {
        //             const parsedpollingFlights = pollingResponse;
		// 			if(parsedpollingFlights.isError !== "1" &&	!parsedpollingFlights.shouldRetry && Number(parsedpollingFlights.isFlights) !== 0) {
        //                     vDispatch(setFlights(parsedpollingFlights, true));
		// 			} else if(parsedpollingFlights.isError !== "1" && parsedpollingFlights.shouldRetry){
		// 					getPollingFlights(pollingId, pollingDelay, pollingLength, vDispatch);
		// 			} else if(parsedpollingFlights.isError === "1" && parsedpollingFlights.shouldRetry) {
        //                 vDispatch(increasePollingCounter());
        //             } else if(parsedpollingFlights.isError === "0" && !parsedpollingFlights.shouldRetry && parsedpollingFlights.isFlights === "0") {
        //                 pollingCheckFailArray.push("fail");
        //                 if(pollingCheckFailArray.length === pollingLength) {
        //                     vDispatch(getFlightsFailed());
        //                 }
        //             }
		// 		})
		// }, pollingDelay);
}

export const getFlights = (flightSearchParams) => {
    return dispatch => {
        dispatch(setLoading());
        const parsedFlights = getFlightsResponse;
        dispatch(setFlights(parsedFlights, false));
        if(parsedFlights.pollingIds.length !== 0) {
            dispatch(setBarLoading());
        }
        let pollingLength = parsedFlights.pollingIds.length;
        emptyPollingCheckArray();
        for (let keyVal = 0; keyVal < 1; keyVal++) {
                let pollingId = parsedFlights.pollingIds[keyVal];
                let pollingDelay = parsedFlights.pollingDelay[pollingId.split("_")[1]];
                getPollingFlights(pollingId, pollingDelay, pollingLength, dispatch);
        }
        // let url = 'http://localhost:3000/flights/getFlights';
        // if(prod) {
        //     url = `https://secure.yatra.com/quicksilvercontroller/flights/getFlights`;
        // }
        // axios.get(
        //   url + flightSearchParams, { headers: {'ssoToken': localStorage.getItem('ssoToken')} }
        // ).then(response => {
        //             const parsedFlights = getFlightsResponse;
        //             dispatch(setFlights(parsedFlights, false));
        //             if(parsedFlights.pollingIds.length !== 0) {
        //                 dispatch(setBarLoading());
        //             }
        //             let pollingLength = parsedFlights.pollingIds.length;
        //             emptyPollingCheckArray();
		// 			for (let keyVal = 0; keyVal < parsedFlights.pollingIds.length; keyVal++) {
		// 					let pollingId = parsedFlights.pollingIds[keyVal];
        //                     let pollingDelay = parsedFlights.pollingDelay[pollingId.split("_")[1]];
		// 					getPollingFlights(pollingId, pollingDelay, pollingLength, dispatch);
		// 			}
        // })
        // .catch(error => {
        //     console.log(error);
        //     dispatch(getFlightsFailed(error));
        // });
    };
};

export const getIntPollingFlights = (pollingId, pollingDelay, pollingLength, vDispatch) => {
    if(!pollingDelay || parseInt(pollingDelay, 10) < 1) {
        pollingDelay = 0;
    }
    let url = 'http://localhost:3000/flights/getIntPollingFlights?polling_id=';
    if(prod) {
        url = `https://secure.yatra.com/quicksilvercontroller/flights/getIntPollingFlights?polling_id=`;
    }
    setTimeout(() => {
            axios.get(
                url + pollingId, { headers: {'ssoToken': localStorage.getItem('ssoToken')} }
            ).then(pollData => {
                const parsedpollingFlights = pollData.data;
                if(parsedpollingFlights.isError.trim() !== "1" && (parsedpollingFlights.shouldRetry === "false" || !parsedpollingFlights.shouldRetry ) && Number(parsedpollingFlights.isFlights) !== 0) {
                        vDispatch(setFlights(parsedpollingFlights, true));
                } else if(parsedpollingFlights.isError.trim() !== "1" && (parsedpollingFlights.shouldRetry === "true" || parsedpollingFlights.shouldRetry)) {
                        getIntPollingFlights(pollingId, pollingDelay, pollingLength, vDispatch);
                } else if(Number(parsedpollingFlights.isError.trim()) === 1 && (parsedpollingFlights.shouldRetry === "true") || parsedpollingFlights.shouldRetry) {
                    vDispatch(increaseIntPollingCounter());
                } else if(parsedpollingFlights.isError === "0" && parsedpollingFlights.shouldRetry === false && parsedpollingFlights.isFlights === "0") {
                    pollingCheckFailArray.push("fail");
                    if(pollingCheckFailArray.length === pollingLength) {
                        vDispatch(getFlightsFailed());
                    }
                }
            })
    }, pollingDelay);
}

export const getIntFlights = (flightSearchParams) => {
    return dispatch => {
        dispatch(setLoading());
        let url = 'http://localhost:3000/flights/getIntFlights';
        if(prod) {
            url = `https://secure.yatra.com/quicksilvercontroller/flights/getIntFlights`;
        }
        axios.get(
           url + flightSearchParams, { headers: {'ssoToken': localStorage.getItem('ssoToken')} }
        ).then(response => {
                    const parsedFlights = response.data;
                    dispatch(setFlights(parsedFlights, false));
                    if(parsedFlights.pollingIds.length !== 0) {
                        dispatch(setBarLoading());
                    }
                    let pollingLength = parsedFlights.pollingIds.length;
                    emptyPollingCheckArray();
					for (let keyVal = 0; keyVal < parsedFlights.pollingIds.length; keyVal++) {
                            let pollingDelay = 0;
                            let pollingId = parsedFlights.pollingIds[keyVal];
                            if(pollingId.split("_")[1] === "aggregatedGds" || pollingId.split("_")[1] === "MULTI") {
                                pollingDelay = 5000;
                            } else {
                                pollingDelay = parsedFlights.pollingDelay[pollingId.split("_")[1]];
                            }
							getIntPollingFlights(pollingId, pollingDelay, pollingLength, dispatch);
					}
        })
        .catch(error => {
            dispatch(getFlightsFailed(error));
        });
    };
}

export const setLoading = () => {
    return {
        type: actionTypes.SET_LOADING
    }
};

export const hideLoading = () => {
    return {
        type: actionTypes.HIDE_LOADING
    }
}

export const filterByPrice = (tripType) => {
    return {
        type: actionTypes.FILTER_BY_PRICE,
        tripType: tripType
    }
}

export const filterByDuration = (tripType) => {
    return {
        type: actionTypes.FILTER_BY_DURATION,
        tripType: tripType
    }
}

export const filterByFlightDeparture = (tripType) => {
    return {
        type: actionTypes.FILTER_BY_FLIGHT_DEPARTURE,
        tripType: tripType
    }
}

export const filterByFlightArrival = (tripType) => {
    return {
        type: actionTypes.FILTER_BY_FLIGHT_ARRIVAL,
        tripType: tripType
    }
}

export const filterByStopOvers = (stop) => {
    return {
        type: actionTypes.FILTER_BY_STOPOVERS,
        stop: stop
    }
}

export const filterByLayoverTime = (timeIndex) => {
    return {
        type: actionTypes.FILTER_BY_LAYOVER_TIME,
        timeIndex: timeIndex
    }
}

export const filterByDepartureTiming = (timeIndex) => {
    return {
        type: actionTypes.FILTER_BY_DEPARTURE_TIMING,
        timeIndex: timeIndex
    }
}

export const filterByReturnTiming = (timeIndex) => {
    return {
        type: actionTypes.FILTER_BY_RETURN_TIMING,
        timeIndex: timeIndex
    }
}

export const filterByAirlines = (target) => {
    return {
        type: actionTypes.FILTER_BY_AIRLINES,
        airlineCode: target.value,
        airlineStatus: target.type === 'checkbox' ? target.checked : target.value
    }
}

export const toggleNonStopFlights = () => {
    return {
        type: actionTypes.TOGGLE_NON_STOP_FLIGHTS
    }
}

export const toggleRefundableFlights = () => {
    return {
        type: actionTypes.TOGGLE_REFUNDABLE_FLIGHTS
    }
}

export const resetFilters = () => {
    return {
        type: actionTypes.RESET_FILTERS
    }
}

export const resetSearch = () => {
    return {
        type: actionTypes.RESET_SEARCH
    }
}

export const hideFiltersUsed = () => {
    return {
        type: actionTypes.HIDE_FILTERS_USED
    }
}

export const hideSearchUsed = () => {
    return {
        type: actionTypes.HIDE_SEARCH_USED
    }
}


export const hideReturnFlights = () => {
    return {
        type: actionTypes.HIDE_RETURN_FLIGHTS
    }
}

export const setBarLoading = () => {
    return {
        type: actionTypes.SET_BAR_LOADING
    }
}

export const showFlightsNotFound = () => {
    return {
        type: actionTypes.SHOW_FLIGHTS_NOT_FOUND
    }
}

export const increasePollingCounter = () => {
    return {
        type: actionTypes.INCREASE_POLLING_COUNTER
    }
}

export const resetPollingCounter = () => {
    return {
        type: actionTypes.RESET_POLLING_COUTNER
    }
}

export const increaseIntPollingCounter = () => {
    return {
        type: actionTypes.INCREASE_INT_POLLING_COUNTER
    }
}

export const updateIntRoundTripTuple = (tupleIndex, itemIndex, type) => {
    return {
        type: actionTypes.UPDATE_INT_ROUND_TRIP_TUPLE,
        tupleIndex: tupleIndex,
        itemIndex: itemIndex,
        intRoundTripType: type
    }
}

export const resetAll = () => {
    return {
        type: actionTypes.RESET_ALL
    }
}

export const selectStop = (stop) => {
    return {
        type: actionTypes.SELECT_STOP,
        stop: stop
    }
}

export const applyFilters = () => {
    console.log("Reached in filters")
    return {
        type: actionTypes.APPLY_FILTERS
    }
}

export const clearFlightsData = () => {
    return {
        type: actionTypes.CLEAR_FLIGHTS_DATA
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/flights.js